"use client";
import React from "react";
import ReactApexChart from "react-apexcharts";

const BarGraphFianancial = ({ title, series, type }) => {
  const colors = ["#26ABA4"];
  const options = {
    chart: {
      height: 250,
      width: "50%",
      type: "bar",
      events: {
        click: function (chart, w, e) {},
      },
    },
    colors: colors,
    plotOptions: {
      bar: {
        columnWidth: "12px", // Increase the width of the bars to decrease the gap between them
        distributed: true,
        barHeight: "100%", // Decrease bar height if you want less height
        horizontal: false, // Ensures the bars are vertical
        dataLabels: {
          position: "top",
        },
        colors: {
          ranges: [
            {
              from: -Infinity,
              to: 0,
              color: "#D30D00", // Red color for negative values
            },
          ],
          backgroundBarColors: [],
          backgroundBarOpacity: 1,
          backgroundBarRadius: 0,
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [
        2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
      ],
      labels: {
        style: {
          colors: "#8B8B8B",
          fontSize: "10px",
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ["#333333"],
          fontSize: "10px",
          fontWeight: "bold",
        },
      },
    },
    toolbar: {
      show: false,
    },
  };
  const options1 = {
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "14px",
        endingShape: "rounded",
      },
      colors: {
        ranges: [
          {
            from: -Infinity,
            to: 0,
            color: "#D30D00", // Red color for negative values
          },
        ],
        backgroundBarColors: [],
        backgroundBarOpacity: 1,
        backgroundBarRadius: 0,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 3,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
      ],
    },
    yaxis: {
      // title: {
      //   text: "$ (thousands)",
      // },
    },
    fill: {
      opacity: 1,
    },
    // tooltip: {
    //   y: {
    //     formatter: function (val) {
    //       return " " + val + " thousands";
    //     },
    //   },
    // },
  };
  const selectedOptions = type ? options1 : options;
  return (
    <div className="border border-solid border-[#d9d9d9] w-[423px] h-max rounded-lg mt-4 overflow-x-auto no-scrollbar">
      <p className="text-sm font-semibold m-4">{title}</p>
      <ReactApexChart
        options={selectedOptions}
        series={series}
        type="bar"
        height={167}
        width={500}
      />
    </div>
  );
};

export default BarGraphFianancial;
